// profile/actions.js
import actionTypes from './actionTypes';

const changeValue = (name, value) => ({
    type: actionTypes.CHANGE_VALUE,
    payload: {
        name,
        value
    }
});

const requestRegister = () => ({
    type: actionTypes.REQUEST_REGISTER
});

const registerResponse = (success, errors) => ({
    type: actionTypes.REGISTER_RESPONSE,
    payload: {
        success,
        errors
    }
});

const requestSave = () => ({
    type: actionTypes.REQUEST_SAVE
});

const saveResponse = (success, errors) => ({
    type: actionTypes.SAVE_RESPONSE,
    payload: {
        success,
        errors
    }
});

const hydrateProfile = profile => ({
    type: actionTypes.HYDRATE_PROFILE,
    payload: {
        profile
    }
});

const requestIndustryTypes = () => ({
    type: actionTypes.REQUEST_INDUSTRY_TYPES
});

const industryTypesResponse = (success, industryTypes, errors) => ({
    type: actionTypes.INDUSTRY_TYPES_RESPONSE,
    payload: {
        success,
        industryTypes,
        errors
    }
});

const requestAccountInfo = () => ({
    type: actionTypes.REQUEST_ACCOUNT_INFO,
});

const accountInfoResponse = (success, errors) => ({
    type: actionTypes.ACCOUNT_INFO_RESPONSE,
    payload: {
        success,
        errors
    }
});

export default {
    changeValue,
    requestRegister,
    registerResponse,
    requestSave,
    saveResponse,
    hydrateProfile,
    requestIndustryTypes,
    industryTypesResponse,
    requestAccountInfo,
    accountInfoResponse
}